import $ from 'jquery';

/*
 * Kentico PageBuilder - the BEDs add extra scripts to the page for this to be enabled.
 * One of them is a jquery plugin.
 * Thus we have to attach jquery to the window so the plugin can access it without throwing an error
 */
window.jQuery = $;
window.$ = $;
window.jquery = $;
